// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "32fcf64fa6f98568df8f" + ".js";
};